import type { RouteComponentProps } from '@gatsbyjs/reach-router';
import { Stack } from '@mui/material';
import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { defineMessages, useIntl } from 'react-intl';

import ContentLoader from '@components/ContentLoader';
import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';
import NullStateDiv from '@components/NullStateDiv';
import ShareHistoryTable from '@components/Tables/ShareHistoryTable';

import { useGetShareHistory } from '@hooks/api/shared_resource';

import ShareInstructions from './ShareInstructions';

const messages = defineMessages({
  noData: {
    id: 'shareHistory.noHistory',
    defaultMessage: 'No Share History',
  },
  revokeAccess: {
    id: 'shareHistory.revokeAccess',
    defaultMessage: 'Revoke Access',
  },
  copyLink: {
    id: 'shareHistory.copyLink',
    defaultMessage: 'Copy Link',
  },
  recreateLink: {
    id: 'shareHistory.recreateLink',
    defaultMessage: 'Re-create Link',
  },
  confirm: {
    id: 'shareHistory.revokeAccessConfirm',
    defaultMessage: 'Are you sure you want to revoke access for {email}?',
  },
});

const ShareHistoryList: React.FC<RouteComponentProps> = () => {
  const { formatMessage } = useIntl();

  const { data = [], loading } = useGetShareHistory();

  return (
    <ContentLoader loading={loading}>
      {data.length === 0 ? (
        <Stack spacing={2}>
          <NullStateDiv>{formatMessage(messages.noData)}</NullStateDiv>
          <ShareInstructions />
        </Stack>
      ) : (
        <ShareHistoryTable data={data} />
      )}
    </ContentLoader>
  );
};

export default withErrorBoundary(ShareHistoryList, {
  FallbackComponent: ErrorBoundaryFallback,
});
